/* istanbul ignore file */
import { alpha, css, StepConnector, styled, useMediaQuery, useTheme } from '@mui/material';
import MUITypography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { StepperComponent } from 'src/components/Stepper';

export function StepMenu({
  step,
  stepTitle,
}: Readonly<{
  step: number;
  stepTitle: string;
}>) {
  const { t } = useTranslation('createProduct');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const orientation = isMobile ? 'horizontal' : 'vertical';

  return (
    <StepMenuContainer data-testid="create-product-wizard-menu">
      <StepMenuContent>
        <StepMenuHeader>{t(stepTitle)}</StepMenuHeader>
        <StepperComponent
          currentStep={step}
          orientation={orientation}
          translationKey="createProduct"
          fullWidth
          largeText
          lighterIcons
          margin={isMobile ? '1rem 0 0 0' : ''}
          label1Key="detailsCAD"
          label2Key="sBOM"
          label3Key="matchReport.sidebarName"
          connector={<StepMenuConnector />}
          blackAndWhiteActiveIcon
        />
      </StepMenuContent>
    </StepMenuContainer>
  );
}

const StepMenuContainer = styled('aside')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  top: 0;
  left: 0;

  ${({ theme }) => css`
    background-color: ${theme.palette.background.paper};
    border-right: 1px solid ${alpha(theme.palette.primary.main, 0.3)};
    border-bottom: 1px solid ${alpha(theme.palette.primary.main, 0.3)};
    border-top: 1px solid ${alpha(theme.palette.primary.main, 0.3)};
  `}

  box-shadow: none;
  position: static;
  min-height: auto;
  width: 100%;
  border: none;
  border-radius: 0;
  padding: 1.5rem 5rem 1.5rem 5rem;

  ${({ theme }) => theme.breakpoints.up('md')} {
    border-bottom-right-radius: 25px;
    border-top-right-radius: 25px;
    min-height: 20rem;
    width: 17rem;
    position: absolute;
    box-shadow: 0 0 0.6rem grey;
    padding: unset;
  }
`;

const StepMenuContent = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100%;
  gap: ${({ theme }) => theme.spacing(0.75)};
  align-items: center;
  padding: 0;

  ${({ theme }) => theme.breakpoints.up('md')} {
    align-items: start;
    padding: ${({ theme }) => theme.spacing(2.5)};
  }
`;

const StepMenuHeader = styled(MUITypography)`
  ${({ theme }) => css`
    font-size: ${theme.typography.h6.fontSize};
    font-weight: ${theme.typography.fontWeightBold};
  `}
  max-width: 100%;
  word-wrap: break-word;
`;

const StepMenuConnector = styled(StepConnector)`
  span {
    border-width: 1px;
    border-color: black;
  }
`;
